const SiteFooter = () => (
  <footer
    data-testid="site-footer"
    className="relative z-10 bg-[#1E3A2F] text-[#F5EFE6] px-8 md:px-16 lg:px-24 py-16 md:py-20"
  >
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-10">
      <div>
        <img
          src="/assets/oneskin-logo-blush.png"
          alt="One Skin"
          data-testid="footer-logo"
          className="w-32 md:w-40 mb-3"
        />
        <p className="text-[11px] tracking-[0.3em] uppercase text-[#C8DDD1]/70 mb-8">
          by OneKind Healthcare LLP
        </p>
        <p className="font-heading text-2xl md:text-3xl leading-snug">
          Science for the skin you have.
          <br />
          <span className="text-[#C8DDD1]">Care for the skin you&#8217;re becoming.</span>
        </p>
      </div>
      <p className="text-xs tracking-[0.25em] uppercase text-[#C8DDD1]/60">
        A OneKind Healthcare LLP venture
      </p>
    </div>
  </footer>
);

export default SiteFooter;
